export default __webpack_public_path__ + "static/media/Defeat_Banner.60507ddb.png";